import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { SubmissionError } from 'redux-form'

import { updateCurrentUser } from '../../ducks/users'

import AppLoader from '../App/AppLoader'
import AuthPage from '../Shared/AuthPage'
import Form from './ProfileSetupForm'

export default function ProfileSetup() {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleSubmit = useCallback(
    async rawValues => {
      const values = {}

      for (let key of Object.keys(rawValues)) {
        const value = rawValues[key]

        values[key] = (value && value.other) || value
      }

      try {
        await dispatch(updateCurrentUser({ onboardingSurvey: values }))
        history.push('/databases/initial-setup')
      } catch (err) {
        console.error(err)
        throw new SubmissionError({ _error: 'An unknown error occurred' })
      }
    },
    [dispatch]
  )

  return (
    <AppLoader>
      <AuthPage>
        <Form onSubmit={handleSubmit} />
      </AuthPage>
    </AppLoader>
  )
}
